<template>
  <fb-list-body :pager="pager" :showSearchForm="true" :showBtnGroup="false"
                @handlePagerSizeChange="handlePagerSizeChange" @handlePagerIndexChange="handlePagerIndexChange">

    <template slot="search-form">
      <el-form-item class="search-form-item" :label="$t('lang.SN码')">
        <el-input :placeholder="$t('lang.SN码')" v-model="searchForm.deviceSn" clearable></el-input>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.型号')">
        <el-select :placeholder="$t('lang.型号')" v-model="searchForm.productCode" clearable>
          <el-option v-for="i in productList" :key="i.code" :label="i.model" :value="i.code"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item" :label="$t('lang.报障类型')">
        <el-select :placeholder="$t('lang.报障类型')" v-model="searchForm.faultType" clearable>
          <el-option v-for="i in faultTypeList" :key="i.sort + '_typekey'" :label="$t(`lang.${i.name}`)" :value="i.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="search-form-item" :label="$t('lang.上报时间')">
        <el-date-picker
            v-model="time"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('lang.开始日期')"
            :end-placeholder="$t('lang.结束日期')">
        </el-date-picker>
      </el-form-item>

      <el-form-item class="search-form-item" label="">
        <el-button size="mini" type="primary" icon="el-icon-search" @click.stop="handleSearch">{{$t('lang.搜索')}}</el-button>
        <el-button size="mini" type="primary" @click.stop="handleReset">{{$t('lang.重置')}}</el-button>
      </el-form-item>
    </template>


    <template slot="table">

      <el-table :data="tableData" @selection-change="handleSelectionChange">

        <el-table-column prop="deviceSn" :label="$t('lang.SN码')" width="150px"></el-table-column>
        <el-table-column prop="brandOwnerName" :label="$t('lang.品牌')"></el-table-column>
        <el-table-column prop="subBrandName" :label="$t('lang.子品牌')"></el-table-column>
        <el-table-column prop="productModel" :label="$t('lang.型号')"></el-table-column>
        <el-table-column prop="productSubModel" :label="$t('lang.子品牌型号')"></el-table-column>
        <el-table-column prop="countryName" :label="$t('lang.国家')"></el-table-column>
        <el-table-column prop="cityName" :label="$t('lang.城市')"></el-table-column>
        <el-table-column prop="faultTypeName" :label="$t('lang.报障类型')"></el-table-column>
        <el-table-column prop="faultTimeStr" :label="$t('lang.报障时间')" width="150"></el-table-column>

        <el-table-column fixed="right" :label="$t('lang.操作')" width="260">
          <template slot-scope="scope">
            <el-button size="mini" @click='$router.push({path: "/test-device-detail",query: {code: scope.row.deviceCode} });' plain  type="primary">{{$t('lang.查看设备')}}</el-button>
            <el-button size="mini" @click='$router.push({path: "",query: {code: scope.row.code} });' plain  type="warning">{{$t('lang.报错日志')}}</el-button>
            <el-button size="mini" plain type="danger"   @click="handleDelete(scope.row)">{{$t('lang.删除')}}</el-button>
          </template>
        </el-table-column>


      </el-table>
    </template>


  </fb-list-body>
</template>

<script>
import {loadDict} from "../../js/common";

export default {
  name: "FaultRecordList",
  components: {},
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime()
      }
    },
  },
  data() {
    return {
      api: {
        list: this.$api.deviceFaultLog.list,
        delete: this.$api.deviceFaultLog.delete,
        batchDelete: this.$api.deviceFaultLog.batchDelete,
      },
      searchForm: {},
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 0
      },
      time: [],
      faultTypeList: []
    }
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
    productList() {
      return this.$store.state.productList;
    }
  },
  watch: {
    time: {
      handler(val) {
        const vm = this;
        if(val.length) {
          vm.searchForm['startTime'] = val[0];
          vm.searchForm['endTime'] = val[1];
        }
      },
      immediate: true,
      deep: true,
    },
    timestamp() {
      this.handleGetData();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true,
      immediate: true
    },
    "pager.pageSize": {
      handler() {

        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams
        });
        this.handleGetData();

      },
      deep: true
    }

  },
  methods: {
    handleSearch() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleGetData();
    },
    handleReset() {
      if(Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.time = [];
        this.handleGetData();
      }
    },
    handleEdit(e) {

      if (e && e.code) {
        this.$router.push({
          path: 'edit',
          query: {
            code: e.code
          }
        });
        return;
      }

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.未选择记录')
        });
        return;
      }

      if (this.selection.length > 1) {
        this.$message({
          type: 'warning',
          message: this.$t('lang.一次只能编辑一条数据')
        });
        return;
      }

      this.$router.push({
        path: 'edit',
        query: {
          code: this.selection[0].code
        }
      });
    },
    handleDelete(row) {


      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(vm.api.delete, vm.$qs.stringify({
          code: row.code
        })).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });

    },
    handleBatchDelete() {


      let vm = this;

      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: vm.$t('lang.未选择记录')
        });
        return;
      }


      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });


      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: 'warning'
      }).then(() => {

        vm.$http.post(this.api.batchDelete, codes).then((resp) => {
          if (resp.data.status === 200) {
            vm.$message({
              type: 'success',
              message: resp.data.desc
            });
            vm.handleGetData();
          } else {
            vm.$message({
              type: 'error',
              message: resp.data.desc
            });

          }
        })


      }).catch(() => {
        // this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        // });
      });


    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleGetData() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {


        for (let key in resp.data.data) {
          if (resp.data.data[key] instanceof Array) {
            vm.tableData = resp.data.data[key];
          }
        }

        //处理分页
        vm.pager.pageIndex = resp.data.data.pager.pageIndex;
        vm.pager.pageSize = resp.data.data.pager.pageSize;
        vm.pager.itemCount = resp.data.data.pager.itemCount;

      })
    }
  },
  async created() {

    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }

    this.faultTypeList = await loadDict(this,'DEVICE_FAULT_TYPE');
  }
}
</script>

<style scoped>

</style>
